import { createAction, props } from '@ngrx/store';
import { IProfileResponse } from '../../../interfaces/profile/IProfileResponse';
import { IAccessKey } from '../../../interfaces/profile/IAccessKey';

export const loadProfile = createAction('[Profile] Load Profile');

export const loadProfileSuccess = createAction(
  '[Profile] Load Profile Success',
  props<{ profile: IProfileResponse }>()
);

export const loadProfileFailure = createAction(
  '[Profile] Load Profile Failure',
  props<{ error: any }>()
);

export const updateProfile = createAction(
  '[Profile] Update Profile',
  props<{ profile: IProfileResponse }>()
);

export const updateProfileSuccess = createAction(
  '[Profile] Update Profile Success',
  props<{ profile: IProfileResponse }>()
);

export const updateProfileFailure = createAction(
  '[Profile] Update Profile Failure',
  props<{ error: any }>()
);

export const loadAvatar = createAction(
  '[Profile] Load Avatar',
  props<{ selectedFile: File }>()
);

export const loadAvatarSuccess = createAction(
  '[Profile] Load Avatar Success',
  props<{ url: string }>()
);

export const loadAvatarFailure = createAction(
  '[Profile] Load Avatar Failure',
  props<{ error: any }>()
);

export const deleteAvatar = createAction('[Profile] Delete Avatar');

export const deleteAvatarSuccess = createAction(
  '[Profile] Delete Avatar Success',
  props<{ status: boolean , message: string }>()
);

export const deleteAvatarFailure = createAction(
  '[Profile] Delete Avatar Failure',
  props<{error : any}>()
);

export const changeEmail = createAction(
  "[Profile] Change Email",
  props<{ new_email: string, profile: IProfileResponse }>()
);
export const changeEmailSuccess = createAction(
  "[Profile] Change Email Success",
  props<{ data: any }>()
);
export const changeEmailFailure = createAction(
  "[Profile] Change Email Failure",
  props<{ error: string | null }>()
);
export const confirmEmail = createAction(
  "[Profile] Confirm Email",
  props<{
    new_email: string;
    confirmationCode: string;
    profile: IProfileResponse;
  }>()
);
export const confirmEmailSuccess = createAction(
  "[Profile] Confirm Email Success",
  // props<{ profile: IProfileResponse }>()
);
export const confirmEmailFailure = createAction(
  "[Profile] Confirm Email Failure",
  props<{ error: string | null }>()
);
export const deleteAccount = createAction(
  "[Profile] Delete Account",
  props<{ reason: {cancelReason: string, otherReason: string} }>()
);
export const deleteAccountSuccess = createAction(
  "[Profile] Delete Account Success"
);
export const deleteAccountFailure = createAction(
  "[Profile] Delete Account Failure",
  props<{ error: string | null }>()
);


export const genearateAccessToken = createAction(
  "[Profile] Generate Access Token",
  
);
export const generateAccessTokenSuccess = createAction(
  "[Profile] Generate Access Token Success",
  props<{ access_token: IAccessKey }>()
);
export const generateAccessTokenFailure = createAction(
  "[Profile] Generate Access Token Failure",
  props<{ error: any }>()
);

export const loadAccessKey = createAction(
  "[Profile] Load Access Key",
  
);
export const loadAccessKeySuccess = createAction(
  "[Profile] Load Access Key Success",
  props<{ access_key: IAccessKey }>()
);
export const loadAccessKeyFailure = createAction(
  "[Profile] Load Access Key Failure",
  props<{ error: any }>()
);


export const deleteAccessKey = createAction(
  "[Profile] Delete Access Key",
);
export const deleteAccessKeySuccess = createAction(
  "[Profile] Delete Access Key Success",
  
);
export const deleteAccessKeyFailure = createAction(
  "[Profile] Delete Access Key Failure",
  props<{ error: any }>()
);